import ServiceBlock from "components/ServiceBlock";

const ServiceList = () => {
  const serviceBlockData = [
    {
      id: "ai-solutions",
      customClass: "bg-brand-purple bg-opacity-10",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="78"
          viewBox="0 0 72 78"
          fill="none"
        >
          <rect
            y="0.000183105"
            width="72"
            height="77.0973"
            rx="9"
            fill="url(#paint0_linear_21_1082)"
          />
          <path
            d="M35.7267 64C31.2605 47.5826 25.7353 41.9244 10 38.6711C10 38.6711 20.54 37.8725 27.4533 30.7987C34.3667 23.7248 35.7267 13 35.7267 13C38.596 29.7696 44.2266 35.2921 61 38.6711C45.2588 42.5067 39.6033 47.9174 35.7267 64Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_1082"
              x1="57.3451"
              y1="3.18603"
              x2="40.1416"
              y2="56.071"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#AC6BFF" />
              <stop offset="1" stop-color="#8756DE" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "AI Innovation and Adoption",
      description: (
        <>
          Our AI Innovation and Adoption service is{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            vendor-agnostic
          </span>{" "}
          and as such allows us to focus solely on your needs, fostering
          innovation while ensuring practical, sustainable AI adoption within
          your organization. We help you navigate the rapidly evolving AI
          landscape, turning emerging technologies into tangible business value
          while fostering a culture of innovation.
        </>
      ),
      infoGrid: {
        title: "Our approach includes:",
        items: [
          "Custom AI Solution Design: We craft bespoke AI solutions tailored to your unique business challenges, prioritizing open-source models and frameworks.",
          <>
            <span style={{ fontWeight: "bold", color: "red" }}>
              Open Source Advantage:
            </span>{" "}
            Leveraging the latest open-source AI models and tools, we ensure
            cost-effective, flexible, and transparent solutions tailored to your
            business needs and',
            <span style={{ fontWeight: "bold", color: "red" }}>
              {" "}
              without VENDOR BIAS!
            </span>{" "}
          </>,
          "Rapid Prototyping and PoCs: We quickly develop proof-of-concepts to demonstrate value and feasibility before full-scale implementation.",
          "Ethical AI Implementation: We prioritize responsible AI development, addressing potential biases and ethical considerations.",
        ],
      },
      logosGrid: {
        title:
          "We incorporate cutting-edge tools like LangChain, Llama, and Pinecone.io to build powerful, scalable AI systems.",
        logos: [
          {
            alt: "Langchain",
            src: require("assets/images/tech-stack/langchain.png"),
          },
          {
            alt: "Mistral",
            src: require("assets/images/tech-stack/mistral.png"),
          },
          {
            alt: "Pinecone",
            src: require("assets/images/tech-stack/pinecone.png"),
          },
          {
            alt: "Meta",
            src: require("assets/images/tech-stack/meta.png"),
          },
          {
            alt: "HuggingFace",
            src: require("assets/images/tech-stack/huggingface.png"),
          },
          {
            alt: "Weights & Biases",
            src: require("assets/images/tech-stack/weightsandbiases.png"),
          },
          {
            alt: "SageMaker",
            src: require("assets/images/tech-stack/sagemaker.png"),
          },
          {
            alt: "Databricks",
            src: require("assets/images/tech-stack/databricks.png"),
          },
          {
            alt: "AWS Bedrock",
            src: require("assets/images/tech-stack/aws_bedrock.png"),
          },
        ],
      },
    },
    {
      id: "digital-transformation",
      customClass: "bg-brand-lightBlue bg-opacity-60",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="80"
          viewBox="0 0 75 80"
          fill="none"
        >
          <rect
            width="75"
            height="80"
            rx="9"
            fill="url(#paint0_linear_53_14)"
          />
          <path
            d="M28.1448 36.3931C28.5841 36.3931 29.0226 36.3354 29.4468 36.2205C29.7124 36.1485 29.9717 36.0542 30.2216 35.9393C30.1756 35.6277 30.1526 35.3132 30.1526 34.9982C30.1526 33.3015 30.8206 31.6893 32.0201 30.4896C32.2754 30.2343 32.552 30.001 32.8465 29.7923C32.5302 28.8771 31.9541 28.0758 31.1868 27.4831C30.3144 26.809 29.2471 26.4464 28.1448 26.4464C26.821 26.4464 25.5638 26.9672 24.628 27.9029C23.6921 28.8388 23.1714 30.0961 23.1714 31.4197C23.1714 32.7433 23.6925 34.0005 24.628 34.9365C25.5638 35.8724 26.8211 36.3931 28.1448 36.3931Z"
            fill="white"
          />
          <path
            d="M33.0123 38.5148C33.9481 39.4507 35.2055 39.9714 36.5291 39.9714C37.8529 39.9714 39.1101 39.4506 40.046 38.5148C40.982 37.579 41.5025 36.3216 41.5025 34.998C41.5025 33.6744 40.9818 32.4171 40.046 31.4812C39.1103 30.5453 37.8529 30.0245 36.5291 30.0245C35.2055 30.0245 33.9482 30.5453 33.0123 31.4812C32.0764 32.417 31.5557 33.6744 31.5557 34.998C31.5557 36.3217 32.0764 37.579 33.0123 38.5148Z"
            fill="white"
          />
          <path
            d="M42.905 34.9979C42.905 35.3129 42.882 35.6275 42.836 35.9391C43.0858 36.0541 43.3451 36.1484 43.6107 36.2203C44.0348 36.3351 44.4733 36.3928 44.9126 36.3928C46.2363 36.3928 47.4936 35.8721 48.4295 34.9363C49.3653 34.0004 49.8862 32.7432 49.8862 31.4196C49.8862 30.0958 49.3654 28.8387 48.4295 27.9028C47.4937 26.9668 46.2363 26.4463 44.9126 26.4463C43.8101 26.4463 42.7429 26.8088 41.8706 27.483C41.1035 28.0758 40.5272 28.8773 40.2109 29.7923C40.5053 30.001 40.7821 30.2344 41.0373 30.4896C42.2369 31.689 42.9049 33.3011 42.9049 34.9978L42.905 34.9979Z"
            fill="white"
          />
          <path
            d="M50.8117 39.2256C49.0865 38.2082 46.8957 37.7958 44.9127 37.7958C44.3828 37.7958 43.852 37.8242 43.325 37.8837C42.9187 37.9296 42.514 37.9938 42.1133 38.0773C41.8236 38.6014 41.4609 39.0833 41.0373 39.5066C40.7149 39.8291 40.3586 40.1164 39.9756 40.3631C41.0763 40.6231 42.1681 41.0246 43.1402 41.5979C44.697 42.5161 46.0765 43.9811 46.0765 45.89V51.0335C46.9775 50.9916 47.8807 50.9002 48.7692 50.7452C49.5441 50.61 50.3274 50.4245 51.0678 50.1567C51.572 49.9744 53.0577 49.3833 53.0577 48.6999V42.3114C53.0577 40.9373 51.9093 39.8725 50.8119 39.2255L50.8117 39.2256Z"
            fill="white"
          />
          <path
            d="M42.4275 42.8037C40.7023 41.7863 38.5117 41.374 36.5286 41.374C34.5455 41.374 32.3546 41.7863 30.6296 42.8037C29.5323 43.4508 28.3838 44.5155 28.3838 45.8897V52.2782C28.3838 52.9933 29.9752 53.5991 30.5012 53.781C31.3672 54.0807 32.2903 54.2749 33.1963 54.4065C34.297 54.5661 35.4167 54.6367 36.5288 54.6367C37.6408 54.6367 38.7605 54.5661 39.8613 54.4065C40.7673 54.2749 41.6903 54.0806 42.5563 53.781C43.0823 53.599 44.6737 52.9932 44.6737 52.2782V45.8897C44.6737 44.5156 43.5253 43.4508 42.4279 42.8037H42.4275Z"
            fill="white"
          />
          <path
            d="M29.9174 41.5978C30.8895 41.0244 31.9812 40.623 33.0821 40.363C32.699 40.1163 32.3426 39.8291 32.0202 39.5065C31.5969 39.0832 31.2341 38.6013 30.9444 38.0772C30.5437 37.9937 30.139 37.9295 29.7325 37.8836C29.2057 37.8241 28.6751 37.7957 28.1449 37.7957C26.1618 37.7957 23.971 38.2081 22.246 39.2255C21.1486 39.8725 20 40.9372 20 42.3114V48.6999C20 49.3834 21.4857 49.9744 21.9899 50.1567C22.7302 50.4245 23.5135 50.61 24.2883 50.7452C25.1768 50.9001 26.0801 50.9914 26.9812 51.0335V45.89C26.9814 43.981 28.3607 42.5159 29.9175 41.5979L29.9174 41.5978Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_53_14"
              x1="66.4195"
              y1="5.59949e-06"
              x2="32.3749"
              y2="34.1443"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A1FDE9" />
              <stop offset="1" stop-color="#80E0D8" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Digital Strategy & Alignment",
      description:
        "Our Digital Strategy & Alignment service helps organizations navigate the complex digital landscape by creating a cohesive, forward-thinking strategy that aligns seamlessly with your business objectives. We work closely with your leadership team to develop a comprehensive digital strategy that not only leverages cutting-edge technologies but also ensures these digital initiatives drive tangible business value.  ",
      infoGrid: {
        title: "Our approach includes:",
        items: [
          "Aligning digital initiatives with overall business goals.",
          "Harmonizing various digital efforts across the organization",
          "Ensuring technology choices support strategic objectives",
          "Bridging the gap between business needs and technological capabilities",
          "Integration & implementation services to ensure outcomes match business objectives.",
        ],
      },
      logosGrid: {
        title: (
          <>
            <span style={{ fontWeight: "bold", color: "red" }}>
              As technology-agnostic experts
            </span>
            , we optimize HR, Finance, Security, and Analytics systems across
            vendors, enhancing real-time data for strategic decisions.
          </>
        ),
        logos: [
          {
            alt: "Workday",
            src: require("assets/images/tech-stack/workday.png"),
          },
          {
            alt: "ADP",
            src: require("assets/images/tech-stack/adp.png"),
          },
          {
            alt: "Paycom",
            src: require("assets/images/tech-stack/paycom.png"),
          },
          {
            alt: "Netsuite",
            src: require("assets/images/tech-stack/netsuite.png"),
          },
          {
            alt: "Tableau",
            src: require("assets/images/tech-stack/tableau.png"),
          },
          {
            alt: "Mosaic",
            src: require("assets/images/tech-stack/mosaic.png"),
          },
          {
            alt: "JumpCloud",
            src: require("assets/images/tech-stack/jumpcloud.png"),
          },
          {
            alt: "Azure Active Directory",
            src: require("assets/images/tech-stack/MSFTAzure.png"),
          },
          {
            alt: "Mulesoft",
            src: require("assets/images/tech-stack/mulesoft_large.png"),
          },
        ],
      },
    },
    {
      id: "vendor-selection",
      customClass: "bg-brand-lightGreen bg-opacity-60",
      icon: (
        <svg
          className="mr-auto"
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="81"
          viewBox="0 0 75 81"
          fill="none"
        >
          <rect
            width="75"
            height="81"
            rx="9"
            fill="url(#paint0_linear_21_816)"
          />
          <path
            d="M43.3919 33.4526L41.8245 32.6348C41.2074 32.3111 40.7511 31.7129 40.5372 30.9122C40.3271 30.1436 40.4198 29.392 40.7966 28.7995L41.7469 27.3078C41.9949 26.9178 41.9381 26.4085 41.6125 26.0829L38.097 22.5675C37.7695 22.2419 37.2603 22.1851 36.8722 22.4331L35.3786 23.3834C34.7842 23.7601 34.0364 23.851 33.2319 23.6333C32.4652 23.427 31.8651 22.9726 31.5433 22.3536L30.7255 20.7861C30.5115 20.3772 30.0402 20.1709 29.5972 20.2902L24.7945 21.5755C24.3478 21.6948 24.0449 22.1094 24.0657 22.5694L24.1471 24.4284C24.1774 25.1212 23.9105 25.8008 23.4126 26.2949C23.4126 26.2968 23.2971 26.4104 23.2971 26.4123C22.803 26.9083 22.1215 27.1809 21.4286 27.1468L19.5696 27.0654C19.0793 27.0635 18.695 27.3494 18.5758 27.7943L17.2904 32.5969C17.1711 33.0418 17.3775 33.5113 17.7864 33.7252L19.3538 34.543C19.9709 34.8648 20.4272 35.4649 20.643 36.2657C20.8531 37.0343 20.7604 37.7858 20.3836 38.3783L19.4333 39.8701C19.1853 40.2601 19.2421 40.7693 19.5677 41.0949L23.0832 44.6103C23.4107 44.9378 23.9199 44.9927 24.308 44.7447L25.7997 43.7963C26.3942 43.4196 27.1438 43.325 27.9465 43.5446C28.7132 43.7509 29.3114 44.2052 29.6351 44.8243L30.4529 46.3917C30.6251 46.723 30.9659 46.9199 31.3256 46.9199C31.4108 46.9199 31.4959 46.9085 31.5792 46.8858L36.3819 45.6004C36.8286 45.4812 37.1315 45.0685 37.1107 44.6066L37.0312 42.7457C37.0009 42.0528 37.2678 41.3732 37.7657 40.8791C37.7657 40.8772 37.8812 40.7636 37.8831 40.7618C38.3772 40.2658 39.0625 40.0083 39.7516 40.0272L41.6106 40.1086C42.1141 40.1257 42.4851 39.8247 42.6044 39.3798L43.8917 34.5772C44.011 34.1323 43.8046 33.6628 43.3957 33.4489L43.3919 33.4526ZM30.5873 38.5125C27.8689 38.5125 25.6635 36.309 25.6635 33.5887C25.6635 30.8703 27.867 28.665 30.5873 28.665C33.3057 28.665 35.5111 30.8685 35.5111 33.5887C35.5111 36.3072 33.3076 38.5125 30.5873 38.5125Z"
            fill="white"
          />
          <path
            d="M56.1105 34.0147C55.7148 33.619 55.0768 33.619 54.6831 34.0147L54.56 34.1377V33.1552C54.56 29.5697 51.6428 26.6523 48.0572 26.6523H46.4821C45.9237 26.6523 45.4731 27.1048 45.4731 27.6613C45.4731 28.2179 45.9237 28.6703 46.4821 28.6703H48.0572C50.5295 28.6703 52.54 30.6808 52.54 33.1531V34.1375L52.4169 34.0145C52.0213 33.6188 51.3833 33.6188 50.9895 34.0145C50.5939 34.4101 50.5939 35.0481 50.9895 35.4418L52.8353 37.2876C53.0246 37.4769 53.282 37.5829 53.5489 37.5829C53.8159 37.5829 54.0733 37.4769 54.2626 37.2876L56.1084 35.4418C56.504 35.0462 56.504 34.4082 56.1084 34.0145L56.1105 34.0147Z"
            fill="white"
          />
          <path
            d="M34.5265 57.1009H32.9515C30.4791 57.1009 28.4687 55.0905 28.4687 52.6181V51.6337L28.5917 51.7568C28.7886 51.9537 29.048 52.0521 29.3054 52.0521C29.5648 52.0521 29.8222 51.9537 30.0191 51.7568C30.4148 51.3611 30.4148 50.7232 30.0191 50.3294L28.1734 48.4837C27.7929 48.1032 27.1246 48.1069 26.746 48.4837L24.9003 50.3294C24.5046 50.7251 24.5046 51.363 24.9003 51.7568C25.2959 52.1524 25.9339 52.1524 26.3276 51.7568L26.4507 51.6337V52.6162C26.4507 56.2017 29.3679 59.1191 32.9536 59.1191H34.5286C35.087 59.1191 35.5376 58.6667 35.5376 58.1101C35.5376 57.5536 35.087 57.1011 34.5286 57.1011L34.5265 57.1009Z"
            fill="white"
          />
          <path
            d="M58.3723 50.2308L57.4088 46.6321C57.2933 46.2005 56.9241 45.9184 56.4452 45.9241L55.05 45.9828C54.5919 45.998 54.1413 45.8257 53.8025 45.4849L53.7267 45.4092C53.3973 45.0817 53.2213 44.6331 53.2402 44.175L53.2989 42.7798C53.3178 42.333 53.0244 41.9298 52.5909 41.8162L48.9922 40.8526C48.5605 40.7372 48.1062 40.9359 47.8961 41.3335L47.2827 42.5091C47.0688 42.918 46.6693 43.219 46.1279 43.3647C45.6092 43.5048 45.1113 43.4461 44.7195 43.1963L43.6007 42.4826C43.224 42.2422 42.7299 42.297 42.4118 42.6132L39.7767 45.2483C39.4605 45.5645 39.4056 46.0605 39.646 46.4372L40.3597 47.556C40.6096 47.9479 40.6683 48.4476 40.5206 48.989C40.3806 49.504 40.0796 49.9053 39.6707 50.1192L38.4951 50.7326C38.0975 50.9389 37.8969 51.3951 38.0142 51.8287L38.9778 55.4274C39.0933 55.859 39.4795 56.1562 39.9414 56.1354L41.3366 56.0748C41.789 56.054 42.2452 56.2319 42.569 56.5575L42.6617 56.6503C42.9911 56.9778 43.1672 57.4284 43.1482 57.8864L43.0896 59.2816C43.0706 59.7284 43.3641 60.1316 43.7976 60.2452L47.3963 61.2088C47.4777 61.2315 47.561 61.2409 47.6443 61.2409C47.9945 61.2409 48.3239 61.0497 48.4924 60.7279L49.1057 59.5523C49.3196 59.1434 49.721 58.8424 50.2605 58.6967C50.7773 58.5547 51.279 58.6153 51.6709 58.8651L52.7896 59.5769C53.1664 59.8155 53.6604 59.7643 53.9785 59.4463L56.6137 56.8112C56.9298 56.495 56.9847 55.999 56.7443 55.6223L56.0306 54.5054C55.7807 54.1135 55.722 53.6119 55.8697 53.0705C56.0079 52.5555 56.3108 52.1542 56.7197 51.9422L57.8934 51.3288C58.2909 51.1224 58.4916 50.6662 58.3742 50.2327L58.3723 50.2308ZM48.1932 54.8538C46.0805 54.8538 44.3691 53.1405 44.3691 51.0297C44.3691 48.9171 46.0824 47.2057 48.1932 47.2057C50.3058 47.2057 52.0172 48.919 52.0172 51.0297C52.0172 53.1424 50.3039 54.8538 48.1932 54.8538Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_816"
              x1="60.3982"
              y1="-6.35386e-07"
              x2="37.1349"
              y2="80.895"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5EEACB" />
              <stop offset="1" stop-color="#33BD9E" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Strategic Vendor Management",
      description:
        "Our Strategic Vendor Management service helps organizations maximize the value of their technology partnerships while minimizing risks. We guide you through the entire vendor lifecycle, from selection to ongoing management, ensuring that your vendor relationships align with and support your business objectives. Our comprehensive approach optimizes your vendor ecosystem, enhances operational efficiency, and drives innovation.",
      infoGrid: {
        title: "Key aspects of this service include:",
        items: [
          "Vendor evaluation and selection aligned with business strategy",
          "Cost optimization and value maximization",
          "Contract negotiation and risk mitigation.",
          "Vendor consolidation and portfolio rationalization.",
          "Performance monitoring and continuous improvement.",
          "Technology roadmap alignment with vendor capabilities.",
          "Vendor relationship cultivation and partnership development.",
        ],
      },
    },
    {
      id: "integration-services",
      customClass: "bg-brand-purple bg-opacity-10",
      icon: (
        <svg
          className="mr-auto"
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="81"
          viewBox="0 0 75 81"
          fill="none"
        >
          <rect
            width="75"
            height="81"
            rx="9"
            fill="url(#paint0_linear_21_842)"
          />
          <rect
            width="75"
            height="80"
            rx="9"
            fill="url(#paint1_linear_21_842)"
          />
          <path
            d="M57.5367 36.1155C55.9537 36.1155 54.6672 37.1308 54.2221 38.533H46.9V34.4717V34.3265H51.0064C51.5505 34.3265 52.0453 33.8914 52.0453 33.3113V28.9115C53.4801 28.4763 54.519 27.2192 54.519 25.6722C54.519 23.7865 52.9853 22.2877 51.0558 22.2877C49.1263 22.2877 47.5926 23.7865 47.5926 25.6722C47.5926 27.2192 48.6315 28.4765 50.0663 28.9115V32.3442H46.3558C45.6137 31.1355 44.278 30.3136 42.7441 30.3136H38.5883V25.6238C40.0231 25.1886 41.062 23.9315 41.062 22.3844C41.062 20.4988 39.5284 19 37.5988 19C35.6693 19 34.1357 20.4988 34.1357 22.3844C34.1357 23.9315 35.1746 25.1888 36.6094 25.6238V30.3136H32.4536C30.9199 30.3136 29.584 31.1355 28.8419 32.3442H25.1314V28.9115C26.5661 28.4763 27.6051 27.2192 27.6051 25.6722C27.6051 23.7865 26.0714 22.2877 24.1419 22.2877C22.2124 22.2877 20.6787 23.7865 20.6787 25.6722C20.6787 27.2192 21.7176 28.4765 23.1524 28.9115V33.3113C23.1524 33.8431 23.5977 34.3265 24.1913 34.3265L28.1 34.3267V34.4718V38.5332L20.7778 38.533C20.3325 37.1308 19.0462 36.1155 17.4632 36.1155C15.5336 36.1155 14 37.6143 14 39.5C14 41.3856 15.5336 42.8844 17.4632 42.8844C19.0462 42.8844 20.3327 41.8691 20.7778 40.467H28.1V44.5283V44.6734H23.9935C23.4494 44.6734 22.9546 45.1086 22.9546 45.6887V50.1368C21.5199 50.572 20.4809 51.8291 20.4809 53.3762C20.4809 55.2618 22.0146 56.7606 23.9441 56.7606C25.8736 56.7606 27.4073 55.2618 27.4073 53.3762C27.4073 51.8291 26.3684 50.5718 24.9336 50.1368V46.6558H28.6441C29.3862 47.8645 30.7219 48.6864 32.2558 48.6864H36.5105V53.3762C35.0758 53.8114 34.0369 55.0685 34.0369 56.6156C34.0369 58.5012 35.5705 60 37.5 60C39.4295 60 40.9632 58.5012 40.9632 56.6156C40.9632 55.0685 39.9243 53.8112 38.4895 53.3762V48.6864H42.6453C44.1789 48.6864 45.5149 47.8645 46.257 46.6558H49.9675L49.9673 50.1368C48.5326 50.572 47.4936 51.8291 47.4936 53.3762C47.4936 55.2618 49.0273 56.7606 50.9568 56.7606C52.8863 56.7606 54.42 55.2618 54.42 53.3762C54.42 51.8291 53.3811 50.5718 51.9463 50.1368V45.6887C51.9463 45.1569 51.501 44.6734 50.9074 44.6734L46.9 44.6733V44.5281V40.4668H54.2222C54.6675 41.869 55.9538 42.8843 57.5368 42.8843C59.4664 42.8843 61 41.3855 61 39.4998C61 37.6142 59.4664 36.1154 57.5368 36.1154L57.5367 36.1155ZM49.5715 25.6721C49.5715 24.8986 50.2147 24.2699 51.0062 24.2699C51.7978 24.2699 52.441 24.8986 52.441 25.6721C52.441 26.4456 51.7978 27.0743 51.0062 27.0743C50.2145 27.0743 49.5715 26.4456 49.5715 25.6721ZM22.5588 25.6721C22.5588 24.8986 23.202 24.2699 23.9935 24.2699C24.7851 24.2699 25.4283 24.8986 25.4283 25.6721C25.4283 26.4456 24.7851 27.0743 23.9935 27.0743C23.2018 27.0743 22.5588 26.4456 22.5588 25.6721ZM17.463 40.9021C16.6714 40.9021 16.0282 40.2735 16.0282 39.4999C16.0282 38.7264 16.6714 38.0978 17.463 38.0978C18.2545 38.0978 18.8977 38.7264 18.8977 39.4999C18.8977 40.2735 18.2545 40.9021 17.463 40.9021ZM25.4282 53.3762C25.4282 54.1498 24.785 54.7784 23.9935 54.7784C23.2019 54.7784 22.5587 54.1498 22.5587 53.3762C22.5587 52.6027 23.2019 51.974 23.9935 51.974C24.7852 51.9742 25.4282 52.6027 25.4282 53.3762ZM36.0651 22.3843C36.0651 21.6108 36.7084 20.9822 37.4999 20.9822C38.2914 20.9822 38.9347 21.6108 38.9347 22.3843C38.9347 23.1579 38.2914 23.7865 37.4999 23.7865C36.7084 23.7865 36.0651 23.1579 36.0651 22.3843ZM38.9347 56.6156C38.9347 57.3892 38.2914 58.0178 37.4999 58.0178C36.7084 58.0178 36.0651 57.3892 36.0651 56.6156C36.0651 55.8421 36.7084 55.2134 37.4999 55.2134C38.2914 55.2134 38.9347 55.8421 38.9347 56.6156ZM41.9031 37.9528L37.3515 42.6427C37.1041 42.8844 36.8073 43.0295 36.4609 43.0295C36.1147 43.0295 35.8177 42.8844 35.5703 42.6427L33.0966 40.0801C32.6513 39.5966 32.6513 38.8714 33.146 38.3879C33.6408 37.9527 34.3829 37.9527 34.8776 38.4362L36.4607 40.0801L40.1218 36.3088C40.5671 35.8253 41.3587 35.8253 41.8534 36.2605C42.3483 36.7441 42.3483 37.5177 41.903 37.9528L41.9031 37.9528ZM52.441 53.3762C52.441 54.1498 51.7978 54.7784 51.0062 54.7784C50.2147 54.7784 49.5715 54.1498 49.5715 53.3762C49.5715 52.6027 50.2147 51.974 51.0062 51.974C51.798 51.9742 52.441 52.6027 52.441 53.3762ZM57.5368 40.9021C56.7453 40.9021 56.1021 40.2735 56.1021 39.4999C56.1021 38.7264 56.7453 38.0978 57.5368 38.0978C58.3284 38.0978 58.9716 38.7264 58.9716 39.4999C58.9716 40.2735 58.3284 40.9021 57.5368 40.9021Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_842"
              x1="66.4195"
              y1="5.66948e-06"
              x2="31.9508"
              y2="34.1429"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A1FDE9" />
              <stop offset="1" stop-color="#80E0D8" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_21_842"
              x1="59.7345"
              y1="3.30579"
              x2="41.939"
              y2="58.2223"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#AC6BFF" />
              <stop offset="1" stop-color="#8756DE" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Enterprise Implementation and Integration",
      description:
        "Our Enterprise Implementation and Integration services go beyond strategy and advice – we roll up our sleeves to deliver tangible results. With deep technical expertise and a proven track record, we implement enterprise-grade vendor software and create fault-tolerant, highly scalable integration solutions. Our team combines strategic insight with practical execution to ensure your technology investments translate into operational success and business value.",
      infoGrid: {
        title: "Our approach includes:",
        items: [
          "End-to-end implementation of enterprise vendor software.",
          "Fault-tolerant system design and implementation.",
          "Design and deployment of robust, scalable integration architectures.",
          "Scalability planning and execution for high-volume environments.",
          "Custom solution development to bridge gaps between systems.",
          "Change management and user adoption strategies.",
          "Data migration and transformation services.",
          "Post-implementation support and continuous improvement.",
          "Performance optimization and tuning.",
        ],
      },
    },
  ];

  return (
    <section className="mx-1 mt-5 grid max-w-7xl grid-cols-1 gap-4 md:grid-cols-2 lg:mx-auto lg:mt-10 lg:gap-8">
      {serviceBlockData.map((data) => (
        <div
          key={data.id}
          id={data.id}
          className={`${data.customClass} rounded-xl px-5 py-6 lg:p-8`}
        >
          <div className="mb-4 flex items-center gap-4 md:flex-row">
            <div className="w-fit">{data.icon}</div>
            <h2 className="text-balance text-2xl font-bold text-black md:text-3xl">
              {data.title}
            </h2>
          </div>
          <p className="my-4 text-lg leading-relaxed text-justify">{data.description}</p>
          <h3 className="mb-2 mt-4 text-xl font-bold">
            {data.infoGrid?.title}
          </h3>
          <ul className="list-disc space-y-2 pl-5">
            {data.infoGrid.items?.map((item, index) => (
              <li key={index} className="text-base leading-snug">
                {item}
              </li>
            ))}
          </ul>
          {data.logosGrid && (
            <div className="mt-6">
              <p className="mb-4 text-lg font-bold">{data.logosGrid.title}</p>
              <div className="mt-auto grid grid-cols-3 gap-4">
                {data.logosGrid.logos.map((logo, index) => (
                  <div
                    key={logo.alt + index}
                    className="flex h-20 items-center justify-center rounded-lg border border-gray-300 bg-white p-2 transition-all duration-200 ease-in-out hover:scale-110"
                  >
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="max-h-full max-w-full object-contain"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </section>
  );
};

export default ServiceList;
